import styled, { css } from 'styled-components';
import { TextArea } from '@bechtel/gds';
export const CommentDescriptionStyled = styled(TextArea)`
  ${({ theme }) =>
    css`
      font-size: ${theme.fontSizes[400]};
      font-family: ${theme.fontFamilies['graphik']};
      color: ${theme.colors.grey[1000]};
    `}
`;
